import React from "react";
import Tilt from "react-parallax-tilt";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faGithub,
  faLinkedin
} from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

export default function Whoami() {
  return (
    <div className="whoami" id="whoami">
      <AnimationOnScroll
        className="whoami__info-animation"
        animateIn="animate__rotateInDownLeft"
        offset="150"
      >
        <Tilt
          className="whoami__info"
          glareEnable={true}
          glareMaxOpacity={0.4}
          tiltMaxAngleX={15}
          tiltMaxAngleY={16}
          glareColor="white"
          glarePosition="all"
          glareBorderRadius="10px"
        >
          <img
            src={"/assets/images/blank-profile-photo.jpeg"}
            alt="personal-pic"
            className="personal-photo"
          />
          <ul className="whoami__info-card">
            <li className="name">
              <span className="bold">Karim Bahri</span>
            </li>
            <li className="education">
              
              <div className="education__info">
                <div className="education__info-wrapper">
                  {/* <img
                    src={"/assets/images/hbnb.png"}
                    alt="hbnb_logo"
                    className="hbnb_logo"
                    width="35px"
                    height="35px"
                  /> */}
                  <span className={"title_job"}>Full-stack <nobr>Web Developer</nobr></span>
                </div>
                {/* <span className="date">2020 - 2022.</span> */}
              </div>
            </li>
            <li className="skills">
              <span className="bold">Contacts : </span>
              <ul className="skiils__list">
                <li><a target="_blank" href="https://www.linkedin.com/in/karim-bahri/"><FontAwesomeIcon className={"fa-icon"} icon={faLinkedin} />LinkedIn</a></li>
                <li><a target="_blank" href="https://github.com/karimbahri/"><FontAwesomeIcon className={"fa-icon"} icon={faGithub} />Github</a></li>
                <li><a href="#contact"><FontAwesomeIcon className={"fa-icon"} icon={faEnvelope} />Email</a></li>
              </ul>
            </li>
          </ul>
        </Tilt>
      </AnimationOnScroll>
      <p className="whami__Detail__Description">
        <AnimationOnScroll
          // animateIn="animate__fadeIn"
          animateIn="animate__fadeIn"
          offset="130"
        >
          Greetings! I am a Full-Stack developer with the ability to learn and collaborate in rapidly changing environments. 
          <br />
          I am hard-working with a flair for creating elegant solutions in the least amount of time.
          <br />
          Passionate about developing scalable web applications and proficient in working across the entire stack, I bring a commitment to delivering efficient and innovative solutions to every project.
        </AnimationOnScroll>
        {/* Full-Stack developer with ability to learn and collaborate in rapidly
        changing environments.
        <br />
        Hard-working with a flair for creating elegant solutions in the least
        amount of time.
        <br />
        Passionate about developing scalable web applications and working across
        the full stack. */}
      </p>
    </div>
  );
}

